import React from 'react'
import classnames from 'classnames'
import { node, oneOfType, arrayOf, bool, func } from 'prop-types'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const CollapsibleCardHeader = ({ icon, children, collapsed, onToggle }) => {
    return (
        <div className='stackable-header columns mx-0 my-0 px-0 py-0 stackable-header'>
            {icon &&
                <div className='column is-1'>
                    <div className='columns mx-0 my-0 py-0'>
                        <div className='column is-12 py-2'>
                            {icon}
                        </div>
                    </div>
                </div>
            }
            <div className={classnames('column columns mx-0 my-0 py-1', { 'is-10 px-0': icon, 'is-11': !icon })}>
                {children}
            </div>
            <div className='column is-1'>
                {onToggle &&
                    <div className='expand-btns is-green' onClick={() => onToggle()}>
                        {!collapsed &&
                            <ExpandLess />
                        }
                        {collapsed &&
                            <ExpandMore />
                        }
                    </div>
                }
            </div>
        </div>)
}

CollapsibleCardHeader.propTypes = {
    icon: node,
    children: oneOfType([arrayOf(node), node]).isRequired,
    collapsed: bool,
    onToggle: func
}

export default CollapsibleCardHeader